import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

function useCapacityBlocks() {
  return useQuery({
    queryKey: ["saas", "capacity-blocks"],
    queryFn: () => apiClient.get("/api/v1/saas/capacity-blocks/").then((r) => r.data),
  });
}

function useBuyBlock() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (kind) =>
      apiClient.post("/api/v1/saas/capacity-blocks/", { kind }).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["saas", "capacity-blocks"] });
      qc.invalidateQueries({ queryKey: ["saas", "subscription"] });
    },
  });
}

function useDeleteBlock() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) =>
      apiClient.delete(`/api/v1/saas/capacity-blocks/${id}/`).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["saas", "capacity-blocks"] });
      qc.invalidateQueries({ queryKey: ["saas", "subscription"] });
    },
  });
}

export { useCapacityBlocks, useBuyBlock, useDeleteBlock };
